











































import { Component, Prop, Vue } from "vue-property-decorator";
import * as rules from '@/rules'

@Component({
    components: {}
})

export default class SupportWindow extends Vue {

    @Prop({default: '', type: String})
    header!: string;

    @Prop({default: '', type: String})
    placeholder!: string;

    @Prop({default: '', type: String})
    hint!: string;

    @Prop({default: '', type: String})
    label!: string;

    @Prop({default: false, type: Boolean})
    dialogProp!: boolean;

    private list: string = '';

    requiredRule = [
        rules.REQUIRED
    ];

    $refs!: {
        form: HTMLFormElement
    };

    mounted() {
    }

    get isDisabled() {
        if (this.list) {
            return false;
        } else {
            return true;
        }
    }

    submit() {
        if (this.list) {
            let listArray: any[] = this.list.split(/\r?\n/);
            listArray.forEach((item, index) => {
                listArray[index] = item.trim();
            }, listArray);
            this.list = '';
            this.$emit('submit', listArray);
        }
    }

    cancel() {
        this.list = '';
        this.$refs.form.reset();
        this.$emit('cancel');
    }

}

